import i18n from '../../managers/i18n'

i18n.register(
  'zh-Hans',
  {
    noData: '没有数据',
    selectAll: '选中全部',
    unselectAll: '取消选中全部',
    selectRow: '选中本行',
    deselectRow: '取消选中本行',
    expandRow: '展开本行',
    collapseRow: '收起本行'
  },
  {
    ns: 'table'
  }
)
